<template>
  <ResumeNote
    class="resume-main-note"
    :value="note && note.text"
    :author-name="note && note.customer"
    :time="note && note.date"
    max-undisguised-length="150"
    :cutouts-number="smOrDown ? 20 : 50"
    @save="saveNote"
  >
    <template v-slot:edit-save-button-content="{ editMode }">
      {{ $tResumePage(editMode ? 'save' : 'edit') }}
    </template>
  </ResumeNote>
</template>

<script>
import windowSizeMixin from '../../mixins/windowSizeMixin';
import ResumeNote from '../resume-helpers/ResumeNote';
import {http} from '../../axios';

export default {
  name: 'ResumeMainNote',
  components: {
    ResumeNote,
  },
  mixins: [windowSizeMixin],
  props: {
    resumeId: Number,
    note: Object,
  },
  methods: {
    async saveNote({ value, callback }) {
      try {
        const { data } = await http.post('/api/new-resume/set-global-note', { resume_id: this.resumeId, note: value });

        if (data) {
          const note = { text: value, customer: this.$tResumePage('I'), date: this.$tResumePage('now') };
          this.$emit('update', note);
          callback();
        }
      } catch {
        this.$vModal.open('Failed to update global note', 'Please check your internet connection or try again later');
      }
    },
  },
};
</script>
